import React from "react";
import "./component.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const RechargeRuleComponent = (props) => {
  return (
    <div className="bp-form-row">
      <div className="bp-form-column">
        <h3 className="bp-section-title">+ Monthly</h3>
        <TextField
          className="bp-form-field"
          fullWidth
          label="Amount"
          type="number"
          id="monthlyAmount"
          name="amount"
          value={props.rechargeData.monthly.amount}
          onChange={(e) => props.handleChangeRecharge(e, "monthly")}
        />
        
        <div className="bp-form-field">
          <label className="bp-form-label">
            Revoke remaining balance at the end of the month
          </label>
          <div className="bp-toggle-group">
            <Button
              className={`bp-toggle-button ${props.activeBtn1 === "Yes" ? "active" : "deleted"}`}
              onClick={() => {
                props.handleAddRechargeBtnClick1("Yes");
                props.handleResetBalanceChange(false);
              }}
            >
              Yes
            </Button>
            <Button
              className={`bp-toggle-button ${props.activeBtn1 === "No" ? "active" : "deleted"}`}
              onClick={() => {
                props.handleAddRechargeBtnClick1("No");
                props.handleResetBalanceChange(true);
              }}
            >
              No
            </Button>
          </div>
        </div>

        <h3 className="bp-section-title">+ Add on</h3>
        <div className="bp-toggle-group">
          <Button
            className={`bp-toggle-button ${props.activeBtn === "Yes" ? "active" : "deleted"}`}
            onClick={() => props.setActiveBtn("Yes")}
          >
            Yes
          </Button>
          <Button
            className={`bp-toggle-button ${props.activeBtn === "No" ? "active" : "deleted"}`}
            onClick={() => props.setActiveBtn("No")}
          >
            No
          </Button>
        </div>

        {props.activeBtn === "Yes" && (
          <>
            <TextField
              className="bp-form-field"
              fullWidth
              label="Add-on Amount"
              type="number"
              id="addOnAmount"
              name="amount"
              value={props.rechargeData.add_on.amount}
              onChange={(e) => props.handleChangeRecharge(e, "add_on")}
            />
            <TextField
              className="bp-form-field"
              fullWidth
              label="Low Balance"
              type="number"
              id="lowBalance"
              name="low_balance"
              value={props.rechargeData.add_on.low_balance}
              onChange={(e) => props.handleChangeRecharge(e, "add_on")}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default RechargeRuleComponent;